import axios from 'axios'
import router from '../../../router'



export const autoLogout = ({dispatch},expires_in)=>{
    setTimeout(()=>{
        dispatch('logout')
    },expires_in*1000)
}

export const login =  function ({commit, dispatch, state, rootState}, credentials) {
    rootState.auth.connecting = true
    commit('initLoginError')
    console.log('url',state)
    return axios.post(rootState.baseurl+'/login', credentials,  {
        headers:{
            'Content-Type':'application/json'
        }
    }).then(resp=>{
        // dispatch('autoLogout', 15000)
        console.log('router',router)
        console.log(resp.data)
        console.log('fournisseur', resp.data.fournisseur)
        commit('token',resp.data.access_token)
        commit('user',resp.data.user)
        commit('fournisseur', resp.data.fournisseur)
        // dispatch('getFields')
        let fetchs = [
        dispatch('getFiles'),
        dispatch('getOtherFiles'),
        dispatch('getMessages')
        ]
        // dispatch('activites')
        Promise.all(fetchs).then(resp=>{
            console.log('all',resp)
            router.push({path:'/dashboard'})
        })
        commit('toogleConnecting')
        router.push({path:'/dashboard'})
        // console.log('vueComp',Login().then())
        // Login().then(resp=>{
        //     console.log('LoginC',resp)
        //     resp.default.methods.re_render()
        // })
        // router.push('/dashboard')
       
        // window.location.reload()
    }).catch(err=>{
        console.log('logError',err)
        commit('toogleConnecting')
        commit('loginError')
    })
}

export const register = async ({rootState},data) => {
    console.log('fournisseur',data.rfournisseur)
    console.log('user',data.user)

    let reqData = {...data.rfournisseur,...data.user}
    return axios.post(rootState.baseurl+'/user-fournisseur', reqData,  {
        headers:{
            'Content-Type':'application/json'
        }
    }).then(resp=>{
        console.log('createF',resp.data.data)
    }).catch(err=>{
        console.log('createFError',err)
    })



}


export const initLoginError = ({commit}) => {
    commit('initLoginError')
}

export const initCheckingUnique = ({commit}) => {
    commit('initCheckingUnique')
}

export const initCheckingMailUnique = ({commit}) => {
    commit('initCheckingMailUnique')
}

export const initConnecting = ({commit}) => {
    commit('initConnecting')
}

export const checkUnique = ({commit,rootState},frnData) => {
    console.log('action checkUnique')
    console.log('frnData',frnData)
    commit('checkingUnique')
    axios.post(rootState.baseurl+'/fournisseur/checkunique', frnData, {
        headers:{
            'Content-Type':'application/json'
        }
    }).then(unique=>{
        commit('initCheckingUnique')
        console.log('uniqueChek',unique)
        console.log('uniqueOK', unique.data.data)
        if(unique.data.data == "exist") commit('uniqueNotOK')
        else commit('uniqueOK')
    }).catch(()=>{
        commit('initCheckingUnique')
    })
}

export const checkMailUnique = ({commit,rootState},email) => {
    console.log('action checkMailUnique')
    console.log('userMail',email)
    commit('checkingMailUnique')
    axios.post(rootState.baseurl+'/users/checkmailunique', {email}, {
        headers:{
            'Content-Type':'application/json'
        }
    }).then(unique=>{
        commit('initCheckingMailUnique')
        console.log('uniqueMailChek',unique)
        console.log('uniqueMailOK', unique.data.data)
        if(unique.data.data == "exist") commit('uniqueMailNotOK')
        else commit('uniqueMailOK')
    }).catch(()=>{
        commit('initCheckingMailUnique')
    })
}

export const uniqueOK = ({commit}) => {
    commit('uniqueOK')
}
export const uniqueMailOK = ({commit}) => {
    commit('uniqueMailOK')
}

export const verifyMail = ({rootState},token) => {
    axios.get(rootState.baseurl+'/email/verify/'+token, {
        headers:{
            'Content-Type':'application/json'
        }
    }).then(resp=>{
        // eslint-disable-next-line no-empty
        if(resp.data.data == 'verified_ok'){
            
        }
    })
}
